<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 设备门禁规则</span>
		</div>
		<div class="content_body">
			<el-card shadow="never" style="height: 80px;">
				<el-row :gutter="24">
					<el-col :span="4">
						<el-input placeholder="规则名称" v-model="searchQuery.name" clearable></el-input>
					</el-col>
          <el-col :span="4">
            <el-input placeholder="设备名称/SN序列号" v-model="searchQuery.deviceName" clearable></el-input>
          </el-col>
					<el-col :span="4">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-button icon="el-icon-plus" type="primary" @click="handleOpenDialog">新增设备门禁规则</el-button>
<!--						<el-button icon="el-icon-download" type="warning" @click="handleDownDeviceRule">下发设备门禁规则</el-button>-->
					</el-col>
				</el-row>
			</el-card>
			<el-card class="card_table" shadow="never">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div class="nodata_text">无数据</div>
						</div>
					</template>
					<el-table-column label="规则名称" prop="name" />
<!--					<el-table-column label="编号" prop="ruleNumber">
					</el-table-column>-->
					<el-table-column label="类型" prop="type">
						<template slot-scope="scope">
							<div v-if="scope.row.type === 1" class="table_scope_t">按周</div>
							<span v-else class="table_scope_f">按时段</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" prop="status">
						<template slot-scope="scope">
							<div v-if="scope.row.status === 1" class="table_scope_t">开启</div>
							<span v-else class="table_scope_f">禁用</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" prop="remark"></el-table-column>
					<el-table-column label="操作" width="140">
						<template slot-scope="scope">
<!--							<el-link style="margin-right: 25px;color:#E6A23C"
								@click="handleBind(scope.row)">绑定</el-link>-->
							<el-link type="primary" style="margin-right: 25px;"
								@click="handleOpenDialog(scope.row)">编辑</el-link>
							<el-link type="danger" style="margin-right: 25px;"
								@click="handleDelete(scope.row)">删除</el-link>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>
		<company-footer-info />
		<device-bind ref="deviceBindRef"/>
		<device-dialog ref="deviceDialogRef" @on-load="handleSearch"/>

    <!-- 下发节假日规则 -->
    <down-device-rule ref="downDeviceRuleRef"/>
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import DeviceBind from "@/views/nexus/deviceRule/deviceBind"
	import DeviceDialog from "@/views/nexus/deviceRule/deviceDialog"
	import {DeviceRuleApi} from "@/api/nexus/deviceRule"
  import DownDeviceRule from "@/views/nexus/deviceRule/downDeviceRule.vue";
	export default {
		components: {
			CompanyFooterInfo,
			DeviceBind,
			DeviceDialog,
      DownDeviceRule
		},
		data() {
			return {
				//查询条件
				searchQuery: {
					name: '',
          deviceName:'',
					pageSize: 20,
					pageNum: 1,
				},
				//表格数据
				tableData: [],
				tableTotal: 0,
			}
		},
		methods: {
			//绑定设备
			handleBind(row) {
				this.$refs.deviceBindRef.show(row.id);
			},
			async handleOpenDialog(row) {
        // if (row.id) {
        //   await this.$confirm("编辑设备门禁规则后需重新绑定设备才能生效。", "提示" )
        // }
				this.$refs.deviceDialogRef.show(row?.id);
			},
      handleDownDeviceRule(row){
          this.$refs?.downDeviceRuleRef?.show(row?.id);
      },
			//删除数据
			async handleDelete(row) {
				await this.$confirm("确认是否删除该数据？", "提示");
				let {code,message} = await DeviceRuleApi.deleteById(row.id);
				if(code == 200){
					this.$message.success("删除成功");
					this.handleSearch()
				}else{
					this.$message.error(message);
				}
				
			},
			//搜索
			handleSearch(){
				this.searchQuery.pageNum = 1;
				this.getDeviceRegulationList();
			},
			//下一页
			handleCurrentChange(page) {
				this.searchQuery.pageNum = page;
				this.getDeviceRegulationList();
			},
			//获取数据
			async getDeviceRegulationList() {
				console.log(this.searchQuery)
				let {data,code} = await DeviceRuleApi.deviceRegulationPage(this.searchQuery);
				if(code == 200){
					this.tableData = data.list;
					this.tableTotal = parseInt(data.total)
				}
			}
		},
		mounted() {
			this.getDeviceRegulationList();
		}
	}
</script>

<style>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.table_scope_t {
		color: #4192F3;
	}

	.table_scope_f {
		color: #EE7B32;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}

	.search-icon {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}
</style>